import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingPOSPanel.scss';

import { updateBrandOnboardingObject } from '../../../Actions/OnboardingActions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import BrandOnboardingProgressBar from '../BrandOnboardingProgressBar';

const BrandOnboardingPOSPanel = props => {
  const { onboarding } = props;
  const usesShopify = onboarding.usesShopify;
  const onNextClick = () => props.goToNextPanel();

  const options = [
    {
      label: 'Shopify',
      selected: !!usesShopify,
      onClick: () => props.updateBrandOnboardingObject({ usesShopify: true })
    },
    {
      label: 'Other',
      selected: usesShopify === false,
      onClick: () => props.updateBrandOnboardingObject({ usesShopify: false })
    }
  ];

  return (
    <div className='brand-onboarding-pos-panel-outer'>
      <div className='brand-onboarding-pos-panel-inner'>
        <div className='brand-onboarding-split-container-outer'>
          <div className='brand-onboarding-split-container-inner'>
            <div className='brand-onboarding-graphic-container-outer'>
              <div className='brand-onboarding-graphic-container-inner'>
                <div className='brand-onboarding-graphic-container-stat'>
                  <div className='brand-onboarding-graphic-container-stat-label'>Our Numbers</div>
                  <div className='brand-onboarding-graphic-container-stat-number'>{props.featuredStat.number}+</div>
                  <div className='brand-onboarding-graphic-container-stat-description'>{props.featuredStat.description}</div>
                </div>

                <BrandOnboardingProgressBar
                  goToPanel={props.goToPanel}
                  sections={props.sections}
                  activeSectionName={props.activeSectionName}
                  activePanelName={props.activePanelName}
                />
              </div>

              <div className='brand-onboarding-graphic-background'>
                <img className='brand-onboarding-graphic-background-image' src={props.backgroundImage} alt='name panel graphic' />
                <div className='brand-onboarding-graphic-background-overlay'></div>
              </div>
            </div>

            <div className='brand-onboarding-input-container-outer'>
              <div className='brand-onboarding-input-container-number-marker'>{props.panelNumber}</div>

              <div className={cn('brand-onboarding-input-container-inner', { isLoading: props.isLoading })}>
                <div className='brand-onboarding-title-text'>Lets set up your POS system</div>
                <div className='brand-onboarding-subtitle-text'>What is your current POS System?</div>

                {options.map((option, index) => (
                  <div key={index} className={`brand-onboarding-pos-panel-option ${option.selected ? 'selected' : ''}`} onClick={option.onClick}>
                    <div className='brand-onboarding-pos-panel-option-label'>{option.label}</div>
                    {option.selected && <FontAwesomeIcon icon={faCircleCheck} className='brand-onboarding-pos-panel-option-icon' />}
                  </div>
                ))}

                <div className='brand-onboarding-pagination-buttons'>
                  <button className='brand-onboarding-button stretch' onClick={() => props.goToPreviousPanel()}>
                    Back
                  </button>
                  <button className='brand-onboarding-button stretch primary' onClick={onNextClick}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandOnboardingPOSPanel.propTypes = {
  onboarding: PropTypes.object.isRequired,
  updateBrandOnboardingObject: PropTypes.func.isRequired,

  goToPreviousPanel: PropTypes.func.isRequired,
  goToNextPanel: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { onboarding } = state;
  return { onboarding };
};

export default connect(mapStateToProps, {
  updateBrandOnboardingObject
})(withRouter(BrandOnboardingPOSPanel));
